import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { clearActionMeta } from "Venues/state";
import { IVenueActions } from "Venues/types";

export const useClearActionMetaOnUnMount = (action: IVenueActions) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearActionMeta(action));
    };
  }, [dispatch, action]);

  return null;
};
